import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import LockIcon from '@mui/icons-material/Lock';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import React from 'react';
import { Link } from '~/components/Link';
import { useUser } from '~/hooks/useUser';

export const profileMenuItems = [
  {
    href: '/dashboard',
    title: 'Dashboard',
    icon: () => <AutoAwesomeMosaicIcon />,
  },
  {
    href: '/settings',
    title: 'Settings',
    icon: () => <SettingsIcon />,
  },
  {
    href: '/logout',
    title: 'Log Out',
    icon: () => <LockIcon />,
  },
];

export const ProfileMenu = () => {
  const [menuElement, setMenuElement] = React.useState<null | HTMLElement>(
    null
  );

  const onMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuElement(event.currentTarget);
  };

  const onMenuClose = () => {
    setMenuElement(null);
  };

  const user = useUser();

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Account Settings">
        <IconButton onClick={onMenuOpen} sx={{ my: 2 }} size="large">
          <AccountCircleIcon style={{ color: 'white' }} fontSize="large" />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        anchorEl={menuElement}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menuElement)}
        onClose={onMenuClose}>
        {!user?.isGuest && (
          <MenuItem disabled divider>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText>{user?.email}</ListItemText>
          </MenuItem>
        )}
        {profileMenuItems.map((item) => {
          return (
            <MenuItem
              onClick={onMenuClose}
              href={item.href}
              key={item.href}
              component={Link}
              LinkComponent={(props) => (
                <Link
                  {...props}
                  href={item.href}
                  underline="none"
                  key={item.href}
                />
              )}>
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText>{item.title}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};
